import React, { useState } from 'react';
import { FilterElementAttributes } from '../types/FilterElementAttributes';
import { ColorNameToHexMapper } from './utils/ColorNameToHexMapper';
import clsx from 'clsx';

const FilterColorCheckbox = ({
  filter,
  option,
  onChange,
}: FilterElementAttributes) => {
  const backgroundColor =
    ColorNameToHexMapper[option?.attributes.cssValue ?? 'white'];

  const [checked, setChecked] = useState<boolean>(
    filter.selectedOptions.indexOf(option.id) != -1
  );

  return option ? (
    <button
      onClick={() => {
        onChange && onChange(filter.id, option.id);
        setChecked(filter.selectedOptions.indexOf(option.id) != -1);
      }}
      className="flex cursor-pointer flex-col items-center justify-center py-1"
    >
      <span
        className={clsx(
          checked
            ? `block h-8 w-8 rounded-lg ${backgroundColor} outline outline-offset-1 outline-gray-700`
            : `block h-8 w-8 rounded-lg ${backgroundColor}`
        )}
      ></span>
      <label key={option.id}>
        <span className="text-md">{option.label}</span>
        <span className="color-gray-500 flex items-center text-sm"></span>
      </label>
    </button>
  ) : null;
};

export default FilterColorCheckbox;
